import { useMemo, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import StoreIcon from "@mui/icons-material/Store";
import InventoryIcon from "@mui/icons-material/Inventory2";
import GroupIcon from "@mui/icons-material/Group";
import VendorsPage from "./pages/VendorsPage";
import ListingsPage from "./pages/ListingsPage";
import TeamPage from "./pages/TeamPage";
import LoginPage from "./pages/LoginPage";
import { AppShell } from "./components/layout";
import "./App.css";

const APP_ENV =
  process.env.REACT_APP_APP_ENV === "development"
    ? "development"
    : "production";

function RequireAuth({ children }) {
  const location = useLocation();

  // In local development, allow access without authentication
  if (
    APP_ENV === "development" ||
    window.location.hostname.includes("localhost")
  ) {
    return children;
  }

  const token =
    typeof window !== "undefined"
      ? localStorage.getItem("token") || localStorage.getItem("auth_token")
      : null;

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

function App() {
  const location = useLocation();
  const [vendors, setVendors] = useState([]);
  const [listings, setListings] = useState([]);
  const [vendorListings, setVendorListings] = useState([]);
  const [listingModalRequest, setListingModalRequest] = useState(null);
  const isLoginPage = location.pathname === "/login";

  const navItems = useMemo(
    () => [
      {
        label: "Vendors",
        path: "/vendors",
        icon: <StoreIcon fontSize="small" />,
        match: /^\/vendors/,
      },
      {
        label: "Listings",
        path: "/listings",
        icon: <InventoryIcon fontSize="small" />,
        match: /^\/listings/,
      },
      {
        label: "Team",
        path: "/team",
        icon: <GroupIcon fontSize="small" />,
        match: /^\/team/,
      },
    ],
    [],
  );

  return (
    <AppShell navItems={navItems} hideChrome={isLoginPage}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Navigate to="/vendors" replace />
            </RequireAuth>
          }
        />
        <Route
          path="/vendors"
          element={
            <RequireAuth>
              <VendorsPage
                vendors={vendors}
                setVendors={setVendors}
                onVendorCreated={(vendor) => {
                  setListingModalRequest({
                    vendorId: vendor.id,
                    nonce: Date.now(),
                  });
                }}
              />
            </RequireAuth>
          }
        />
        <Route
          path="/listings"
          element={
            <RequireAuth>
              <ListingsPage
                listings={listings}
                setListings={setListings}
                vendors={vendors}
                setVendors={setVendors}
                setVendorListings={setVendorListings}
                vendorListings={vendorListings}
                listingModalRequest={listingModalRequest}
              />
            </RequireAuth>
          }
        />
        <Route
          path="/team"
          element={
            <RequireAuth>
              <TeamPage />
            </RequireAuth>
          }
        />
      </Routes>
    </AppShell>
  );
}

export default App;
